const CollapseIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#E0F1FE" />
      <g filter="url(#filter0_d_1785_50831)">
        <path
          d="M5.05839 16.0058C5.05839 18.1709 5.70044 20.2875 6.90335 22.0878C8.10626 23.8881 9.81601 25.2912 11.8164 26.1198C13.8167 26.9484 16.0179 27.1652 18.1415 26.7428C20.2651 26.3204 22.2157 25.2777 23.7467 23.7467C25.2777 22.2157 26.3204 20.2651 26.7428 18.1415C27.1652 16.0179 26.9484 13.8167 26.1198 11.8164C25.2912 9.81601 23.8881 8.10626 22.0878 6.90335C20.2875 5.70044 18.1709 5.05839 16.0058 5.05839C13.1023 5.05839 10.3178 6.21177 8.2648 8.2648C6.21177 10.3178 5.05839 13.1023 5.05839 16.0058ZM18.38 10.9015C18.6231 11.1475 18.7595 11.4794 18.7595 11.8252C18.7595 12.1711 18.6231 12.503 18.38 12.7489L15.0889 16.0058L18.38 19.2558C18.6227 19.5005 18.7589 19.8313 18.7589 20.176C18.7589 20.5207 18.6227 20.8515 18.38 21.0963C18.1314 21.3424 17.7958 21.4804 17.446 21.4804C17.0962 21.4804 16.7606 21.3424 16.5121 21.0963L12.2973 16.9294C12.0542 16.6835 11.9178 16.3516 11.9178 16.0058C11.9178 15.6599 12.0542 15.328 12.2973 15.0821L16.5121 10.9084C16.7646 10.6708 17.0979 10.538 17.4447 10.5367C17.7914 10.5354 18.1257 10.6658 18.38 10.9015Z"
          fill="#313e77" //#082c49
        />
        <path
          d="M18.6794 10.6055L18.6729 10.599L18.6662 10.5928C18.3337 10.2845 17.8965 10.114 17.4431 10.1157C16.9897 10.1173 16.5538 10.291 16.2236 10.6017L16.2235 10.6016L16.2158 10.6092L12.0011 14.7829L12.001 14.7829L11.9979 14.786C11.6768 15.1108 11.4967 15.549 11.4967 16.0058C11.4967 16.4625 11.6768 16.9007 11.9979 17.2255L11.9979 17.2255L12.0013 17.2289L16.2158 21.3955C16.2159 21.3955 16.2159 21.3956 16.216 21.3957C16.216 21.3957 16.216 21.3957 16.216 21.3957C16.5434 21.7197 16.9854 21.9015 17.446 21.9015C17.9067 21.9015 18.3488 21.7196 18.6762 21.3955L18.6789 21.3928C18.9999 21.0692 19.18 20.6318 19.18 20.176C19.18 19.7202 18.9999 19.2829 18.6789 18.9593L18.6789 18.9592L18.6758 18.9562L15.6878 16.0054L18.6761 13.0482L18.6762 13.0482L18.6794 13.045C19.0005 12.7202 19.1806 12.2819 19.1806 11.8252C19.1806 11.3685 19.0005 10.9302 18.6794 10.6055ZM7.25344 21.8539C6.0968 20.1228 5.47944 18.0877 5.47944 16.0058C5.47944 13.214 6.58846 10.5366 8.56252 8.56252C10.5366 6.58846 13.214 5.47944 16.0058 5.47944C18.0877 5.47944 20.1228 6.0968 21.8539 7.25344C23.5849 8.41009 24.9341 10.0541 25.7308 11.9775C26.5275 13.9009 26.736 16.0174 26.3298 18.0593C25.9236 20.1012 24.9211 21.9769 23.449 23.449C21.9769 24.9211 20.1012 25.9236 18.0593 26.3298C16.0174 26.736 13.9009 26.5275 11.9775 25.7308C10.0541 24.9341 8.41009 23.5849 7.25344 21.8539Z"
          stroke="#FFFFFF"
          stroke-width="0.842105"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1785_50831"
          x="1.69017"
          y="2.53228"
          width="28.6314"
          height="28.6314"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.842105" />
          <feGaussianBlur stdDeviation="1.68421" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1785_50831"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1785_50831"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default CollapseIcon;
